export const SocialMediaChannelOptions = [
  { id: 'facebook', name: 'Facebook' },
  { id: 'instagram', name: 'Instagram' },
  { id: 'pinterest', name: 'Pinterest' },
  { id: 'youtube', name: 'Youtube' },
  { id: 'tiktok', name: 'TikTok' },
  { id: 'linkedin', name: 'LinkedIn' },
  { id: 'reddit', name: 'Reddit' },
  { id: 'other', name: 'txt_other' },
];
